import DOMPurify from 'dompurify';

// Helpers shared by the admin's rich-text editor (`RichTextField`) and the
// public renderer (`RichText`). They live here rather than next to the editor so
// that rendering a stored value does not drag Tiptap into the public bundle.

/**
 * Strips anything a browser would execute. `target`/`rel` are kept explicitly —
 * DOMPurify drops `target` by default, and the editor writes links with it.
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, { ADD_ATTR: ['target', 'rel'] });
}

/** Tiptap emits `<p></p>` for an empty document; normalize that (and blank input) to ''. */
export function normalizeRichText(html: string): string {
  const trimmed = html.trim();
  if (trimmed === '' || trimmed === '<p></p>') return '';
  return sanitizeHtml(trimmed);
}

const escapeHtml = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/**
 * Turns a stored value into HTML. Text saved before a field became rich text
 * (no tags in it) keeps its line breaks as one paragraph per line; anything
 * already carrying markup is passed through as the HTML it is.
 */
export function toRichTextHtml(value: string): string {
  if (value === '') return '';
  if (!value.includes('<')) {
    return value
      .split('\n')
      .filter(Boolean)
      .map((line) => `<p>${escapeHtml(line)}</p>`)
      .join('');
  }
  return value;
}
